module.exports = __webpack_public_path__ + "static/media/rocket.57dd7e26.svg";